import { Component, ChangeDetectorRef, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs/operators';
import moment from 'moment/min/moment-with-locales';
import { Router, RouterModule } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScheduleEvent, ScheduleViewModel } from '../../../shared/models/ScheduleModels';
import { ScheduleService } from '../../../shared/services/schedule.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { Globals } from '../../../shared/models/globals';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScheduleMenuComponent } from '../../components/schedule-menu/schedule-menu.component';
import { GameEventComponent } from '../../components/game-event/game-event.component';
import { GenericEventComponent } from '../../components/generic-event/generic-event.component';
import { GroupEventByUTCDatePipe } from '../../../shared/pipes/group-event-by-utcdate-pipe.pipe';

@Component({
  selector: 'app-schedule-coming',
  imports: [CommonModule, MaterialModule, TranslateModule, RouterModule, GameEventComponent, GenericEventComponent, GroupEventByUTCDatePipe],
  templateUrl: './schedule-coming.component.html',
  styleUrl: './schedule-coming.component.css'
})
export class ScheduleComingComponent implements OnInit {
  currentYear: number;
  currentMonth: number;
  currentDay: number;
  currentMonthText: string;
  isLoading: boolean = false;
  dateRows: string[] = [];


  private scheduleService = inject(ScheduleService);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  schedule: ScheduleViewModel | null = null;


    ngOnInit() {
  
      //moment.locale('sv');
      var now = new Date();
      this.currentYear = now.getFullYear();
      this.currentMonth = now.getMonth();
      this.currentDay = now.getDate();
      var m =  moment().set({'year': this.currentYear, 'month': this.currentMonth, 'date': 1});//.add(1, 'months');
  
      
      this.currentMonthText = m.format('MMMM');
  
      this.getScheduleData();
      
  
    }


    getScheduleData() {
      if (this.isLoading) {
        // console.log('Coming view - already loading, skipping duplicate call');
        return;
      }
      
      this.isLoading = true;
      // console.log('Coming view - starting to load data');
      //console.log(this.currentYear + '-' + (this.currentMonth+1));



      this.scheduleService.getScheduleComing()
        .pipe(
          finalize(() => {
            // console.log('Coming view - finalize, setting isLoading to false');
            this.isLoading = false;
            this.cdr.detectChanges();
          })
        )
        .subscribe({
          next: (data) => {
            this.schedule = data;
            // console.log('Coming view - data loaded successfully, events:', data.EventList?.length || 0);
            this.cdr.detectChanges();
            //console.log(this.schedule);


            //console.log("kjlkj");
          },
          error: (error) => {
            // console.error('Error loading coming schedule:', error);
          }
        });
  }

  deleteEventFromCalendar(eventId: string) {
    this.scheduleService.removeEventFromSchedule(eventId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.getScheduleData();
      });
  }
/* 
  addDateRow(date: Date | undefined): boolean {
    if (!date) return false;
    const formattedDate = moment(date).format('DD MMM');
    if (!this.dateRows.includes(formattedDate)) {
      this.dateRows.push(formattedDate);
      // console.log(`Added date row: ${formattedDate}`);
      return true;
    } else {
      // console.log(`Found: ${formattedDate}`);
      return false;
    }

  }

  addDateRow(currentDate: Date | undefined, previousDate: Date | undefined): boolean {
    if (!currentDate) return false;
    const formattedCurrent = moment(currentDate).format('DD MMM');
    const formattedPrevious = previousDate ? moment(previousDate).format('DD MMM') : null;
    return formattedCurrent !== formattedPrevious;
  } */
}
